'use client';

import { usePathname } from 'next/navigation';

export default function ClientLayout({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  return (
    <>
      {pathname !== '/read' && (
        <>
          <div className="border-b border-gray-300 h-12">Header</div>
          {children}
          <div className="border-t border-gray-300 h-12">footer</div>
        </>
      )}

      {pathname === '/read' && <>{children}</>}
    </>
  );
}
